import {getCountriesCatalogService} from '@/services/marketsService'
import {GetCountriesCatalogResponse} from '@/types/Markets'

export async function getCountriesCatalogUseCase(signal?: AbortSignal): Promise<GetCountriesCatalogResponse> {
  return getCountriesCatalogService(signal)
}
